import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const useTestimonials = (fallback = []) => {
  const [testimonials, setTestimonials] = useState(fallback);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios
      .get(`${API}/testimonials`)
      .then((r) => { if (r.data.length) setTestimonials(r.data); })
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return { testimonials, loaded };
};
